Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;var _default=[{
fontFamily:'AntDesign',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/AntDesign.ttf')
},{
fontFamily:'Entypo',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Entypo.ttf')
},{
fontFamily:'FontAwesome',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/FontAwesome.ttf')
},{
fontFamily:'HK Grotesk Black Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Black Italic.otf')
},{
fontFamily:'HK Grotesk Black',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Black.otf')
},{
fontFamily:'HK Grotesk Bold Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Bold Italic.otf')
},{
fontFamily:'HK Grotesk Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Bold.otf')
},{
fontFamily:'HK Grotesk Extra Bold Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Extra Bold Italic.otf')
},{
fontFamily:'HK Grotesk Extra Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Extra Bold.otf')
},{
fontFamily:'HK Grotesk Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Italic.otf')
},{
fontFamily:'HK Grotesk Light Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Light Italic.otf')
},{
fontFamily:'HK Grotesk Light',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Light.otf')
},{
fontFamily:'HK Grotesk Medium Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Medium Italic.otf')
},{
fontFamily:'HK Grotesk Medium',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Medium.otf')
},{
fontFamily:'HK Grotesk Regular',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Regular.otf')
},{
fontFamily:'HK Grotesk Semi Bold Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Semi Bold Italic.otf')
},{
fontFamily:'HK Grotesk Semi Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Semi Bold.otf')
},{
fontFamily:'HK Grotesk',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk.otf')
},{
fontFamily:'Ionicons',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Ionicons.ttf')
},{
fontFamily:'MaterialCommunityIcons',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/MaterialCommunityIcons.ttf')
},{
fontFamily:'MaterialIcons',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/MaterialIcons.ttf')
},{
fontFamily:'Roboto Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Roboto Bold.ttf')
},{
fontFamily:'Roboto Light',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Roboto Light.ttf')
},{
fontFamily:'Roboto Medium',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Roboto Medium.ttf')
},{
fontFamily:'Roboto',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Roboto.ttf')
},{
fontFamily:'Source Sans Pro Black',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro Black.otf')
},{
fontFamily:'Source Sans Pro BlackIt',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro BlackIt.otf')
},{
fontFamily:'Source Sans Pro Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro Bold.otf')
},{
fontFamily:'Source Sans Pro BoldIt',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro BoldIt.otf')
},{
fontFamily:'Source Sans Pro Extra Light',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro Extra Light.otf')
},{
fontFamily:'Source Sans Pro Extra LightIt',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro Extra LightIt.otf')
},{
fontFamily:'Source Sans Pro It',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro It.otf')
},{
fontFamily:'Source Sans Pro Light',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro Light.otf')
},{
fontFamily:'Source Sans Pro LightIt',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro LightIt.otf')
},{
fontFamily:'Source Sans Pro Regular',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro Regular.otf')
},{
fontFamily:'Source Sans Pro SemiBold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro SemiBold.otf')
},{
fontFamily:'Source Sans Pro SemiboldIt',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Source Sans Pro SemiboldIt.otf')
},{
fontFamily:'Syne Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Syne Bold.otf')
},{
fontFamily:'Syne Extra',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Syne Extra.otf')
},{
fontFamily:'Syne ExtraBold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Syne ExtraBold.ttf')
},{
fontFamily:'Syne Medium',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Syne Medium.ttf')
},{
fontFamily:'Syne Mono',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Syne Mono.otf')
},{
fontFamily:'Syne Regular',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Syne Regular.otf')
},{
fontFamily:'Syne SemiBold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Syne SemiBold.ttf')
},{
fontFamily:'Syne Talic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/covington/fonts/Syne Talic.otf')
}];exports.default=_default;